// assets
import { MenuIcon } from 'components/ui-component/icons';

// constant
const icons = {
  MenuIcon: () => <MenuIcon size="32px" />
};


// ==============================|| ADMIN MENU ITEMS ||============================== //

const admin_nav = [

  {
    id: 'basic-info-management',
    title: '기초정보관리',
    type: 'group',
    icon: icons.MenuIcon,
    url: '/basic-info',
    children: [
      {
        id: 'management-company-info',
        title: '회사정보',
        type: 'item',
        url: '/basic-info/company-info'
      },
      {
        id: 'basic-info-organization-info',
        title: '조직정보',
        type: 'collapse',
        children: [
          {
            id: 'basic-info-department-position',
            title: '부서·직급 정보',
            type: 'item',
            url: '/basic-info/company-info/department'
          },
          // {
          //   id: 'basic-info-approval-line',
          //   title: '결재라인',
          //   type: 'item',
          //   url: '/basic-info/company-info/approval-line'
          // }
        ]
      },
      {
        id: 'hrm-management',
        title: '인사관리',
        type: 'collapse',
        children: [
          {
            id: 'employee-info',
            title: '사원정보',
            type: 'item',
            url: '/basic-info/hrm/employee'
          },
          {
            id: 'employee-list',
            title: '직원명부 조회',
            type: 'item',
            url: '/basic-info/hrm/employee/list'
          },
          {
            id: 'retired-employee-list',
            title: '퇴직자명부 조회',
            type: 'item',
            url: '/basic-info/hrm/employee/retired-list'
          }
        ]
      },
      {
        id: 'basic-info-attendance-info',
        title: '근태정보',
        type: 'collapse',
        children: [
          {
            id: 'basic-info-work-time',
            title: '기본근로시간',
            type: 'item',
            url: '/basic-info/attendance/work-time'
          },

          {
            id: 'basic-info-holiday-info',
            title: '휴일정보',
            type: 'item',
            url: '/basic-info/holiday'
          },
        ]
      },
      {
        id: 'basic-info-salary-info',
        title: '급여항목관리',
        type: 'collapse',
        children: [
          {
            id: 'basic-info-4-insurance-rate',  // 변경됨
            title: '4대보험요율',
            type: 'item',
            url: '/basic-info/salary/4-insurance'
          },
          {
            id: 'basic-info-salary-items',
            title: '급여항목',
            type: 'item',
            url: '/basic-info/salary/item'
          },
          {
            id: 'management-simple-tax',
            title: '간이세액표',
            type: 'item',
            url: '/basic-info/salary/simple-tax'
          }
        ]
      }
    ]
  },
  {
    id: 'attendance-management',
    title: '근태관리',
    type: 'group',
    icon: icons.MenuIcon,
    url: '/attendance',
    children: [
      {
        id: 'attendance-management',
        title: '출퇴근결과 조회',
        type: 'item',
        url: '/attendance/management'
      },
      {
        id: 'daily-attendance',
        title: '일별 근태조회',
        type: 'item',
        url: '/attendance/daily'
      },
      {
        id: 'work-time-list',
        title: '출퇴근 기록 조회',
        type: 'item',
        url: '/attendance/tag'
      }
    ]
  },
  {
    id: 'salary-management',
    title: '급여관리',
    type: 'group',
    icon: icons.MenuIcon,
    url: '/salary',
    children: [
      {
        id: 'salary-management',
        title: '급여명세서',
        type: 'item',
        url: '/salary/management'
      },
      {
        id: 'salary-list',
        title: '급여대장 조회',
        type: 'item',
        url: '/salary/payment-list'
      },
      {
        id: 'salary-transfer',
        title: '급여이체현황',
        type: 'item',
        url: '/salary/transfer'
      },
      {
        id: 'salary-payment-list-year',
        title: '총급여지급내역',
        type: 'item',
        url: '/salary/payment-year-list'
      },
      {
        id: 'salary-leave-list',
        title: '연차사용내역 조회',
        type: 'item',
        url: '/salary/leave/list'
      },
      {
        id: 'salary-leave-payment-list',
        title: '연차수당 조회',
        type: 'item',
        url: '/salary/leave/payment-list'
      },
      {
        id: 'retirement-pension',
        title: '퇴직연금내역',
        type: 'item',
        url: '/salary/insurance-tax/retirement-pension'
      },
      {
        id: 'account-book',
        title: '전표 조회',
        type: 'item',
        url: '/salary/account-book'
      },
      {
        id: 'labor-cost-statement',
        title: '노무비내역서',
        type: 'item',
        url: '/salary/labor-cost-statement'
      },
    ]
      // {
      //   id: 'salary-insurance-tax',
      //   title: '퇴직연금',
      //   type: 'collapse',
      //   url: '/salary/insurance-tax',
      //   children: [
      //     {
      //       id: 'retirement-pension',
      //       title: '퇴직연금내역',
      //       type: 'item',
      //       url: '/salary/insurance-tax/retirement-pension'
      //     },
      //   ]
      // },
    // ]
  },
  {
    id: 'insurance-management',
    title: '외국인보험',
    type: 'group',
    icon: icons.MenuIcon,
    url: '/insurance-tax',
    children: [
      {
        id: 'departure-guarantee',
        title: '출국만기보험내역',
        type: 'item',
        url: '/insurance-tax/departure-guarantee'
      },
    ]
  },
  {
    id: 'electronic-approval',
    title: '전자결재',
    type: 'group',
    icon: icons.MenuIcon,
    url: '/e-system',
    children: [
      {
        id: 'total-status',
        title: '전체 현황 조회',
        type: 'item',
        url: '/e-system/total'
      },
      {
        id: 'vacation-status',
        title: '휴가신청 현황',
        type: 'item',
        url: '/e-system/vacation'
      },
      {
        id: 'leave-status',
        title: '근태신청 현황',
        type: 'item',
        url: '/e-system/attendance'
      },
      {
        id: 'business-trip-status',
        title: '출장신청 현황',
        type: 'item',
        url: '/e-system/trip'
      },
      {
        id: 'education-status',
        title: '교육신청 현황',
        type: 'item',
        url: '/e-system/edu'
      },
      {
        id: 'overtime-status',
        title: '연장근무신청 현황',
        type: 'item',
        url: '/e-system/over'
      },
      {
        id: 'apology-status',
        title: '시말서작성 현황',
        type: 'item',
        url: '/e-system/apology'
      },
    ]
  },
  {
    id: 'device-management',
    title: '기기관리',
    type: 'group',
    icon: icons.MenuIcon,
    url: '/terminal',
    children: [
      {
        id: 'beacon-device',
        title: '비콘단말기 관리',
        type: 'item',
        url: '/terminal/company-beacon'
      },
      {
        id: 'mobile-device',
        title: '등록기기',
        type: 'item',
        url: '/terminal/company-mobile'
      }
    ]
  },
  {
    id: 'help-management',
    title: '',
    type: 'group',
    url: '/help',
    children: [
      {
        id: 'help-manual',
        title: '사용설명서(도움말)',
        type: 'item',
        url: '/help/manual'
      },
      {
        id: 'help-faq',
        title: '자주 묻는 질문',
        type: 'item',
        url: '/help/faq'
      },
      {
        id: 'service-info',
        title: '참고 사항',
        type: 'item',
        url: '/help/reference'
      },
      {
        id: 'notice-board',
        title: '공지사항',
        type: 'item',
        url: '/board/notice'
      },
      {
        id: 'file-board',
        title: '양식다운로드',
        type: 'item',
        url: '/board/file'
      }
      // {
      //   id: 'help-inquiry',
      //   title: '1:1문의',
      //   type: 'item',
      //   url: '/help/inquiry'
      // },
      // {
      //   id: 'help-remote-support',
      //   title: '원격지원',
      //   type: 'item',
      //   url: '/help/remote-support'
      // }
    ]
  }

];


export default admin_nav;